export default "__VITE_ASSET__CvzIWMF0__"